<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 md10 offset-md1 lg8 offset-lg2>
        <v-breadcrumbs divider="/">
          <v-breadcrumbs-item :to="{ name: 'my-services' }" exact>Mine tjenester</v-breadcrumbs-item>
          <v-breadcrumbs-item disabled>Webhotell</v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
        <notifications group="webhotel-list" key="webhotel-list" />

        <v-data-table
          :headers="headers"
          :items="webhotels"
          hide-actions
          class="elevation-1"
          item-key="servername"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">
              <router-link class="big-link" :to="{ 'name': 'webhotel-detail', params: { servername: props.item.servername } }">
                {{ props.item.servername }}
              </router-link>
            </td>
            <td class="text-xs-left">{{ props.item.aliases.join(', ') }}</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import WebhotelService from '@/services/WebhotelService'

export default {
  name: 'email-list',
  mounted () {
    this.init()
  },
  data () {
    return {
      isSubmitting: false,
      headers: [
        { text: 'Webhotell', sortable: false, class: 'has-big-links' },
        { text: 'Aliaser', sortable: false }
      ],
      webhotels: []
    }
  },
  methods: {
    async init () {
      const response = await this.runService(this, 'webhotel-list', WebhotelService.getList)
      if (response) {
        this.webhotels = response.data
      }
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 340px !important;
  font-size: 1.2em;
}

.card .v-btn {
  font-size: 1em;
}
</style>
